import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

export default (domElement, configs, sellerInfo, listings, requestedListingId = null, settings, membershipConfig, embeddedCheckout = null, embeddedCheckoutElement = null, orgListingQueueSettings = null) => {
    const updateOrgListingConfig = (orgListingConfig: object) => {
        if (embeddedCheckout && embeddedCheckoutElement) {
            embeddedCheckout.updateOrgListingConfig(orgListingConfig);
        }
    }

    const renderApp = (embedError: boolean = false) => {
      const root = createRoot(domElement);
      root.render(
            <App
                configs={configs}
                sellerInfo={sellerInfo}
                listings={listings}
                requestedListingId={+requestedListingId}
                embeddedCheckout={embeddedCheckout}
                embedCaughtRenderingError={embedError}
                settings={settings}
                membershipConfig={membershipConfig}
                updateOrgListingConfig={updateOrgListingConfig}
                orgListingQueueSettings={orgListingQueueSettings}
            />
        )
    }
    if (embeddedCheckout && embeddedCheckoutElement) {
        embeddedCheckout.setRenderingErrorCallback(() => {
            renderApp(true);
        })
        embeddedCheckout.embed(embeddedCheckoutElement);
    }
    renderApp();
}
